import $ from 'jquery';

$( '.content-slider' ).slick( {
	slidesToShow: 4,
	autoplay: false,
	draggable: true,
	speed: 750,
	infinite: false,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 500,
			settings: {
				slidesToShow: 1,
			}
		},
	]
} );
